import { createSelector } from 'reselect';

import { composeProps } from '@mews/framework/redux';

import {
    getEnterpriseSupportedPaymentCardTypes,
    getEnterpriseSupportedPaymentMethods,
    hasEnterpriseMewsMerchant,
    hasEnterpriseNonePaymentGatewayType,
    hasEnterprisePciProxyStorage,
    isEnterpriseModelMerchantOfRecord,
} from '../../modules/paymentConfigurations/selectors';
import { selectedEnterpriseIdPropsExtender } from '../../modules/resourceOrder/selectors';

/*
 * If possible, avoid using the contextual selectors from this file in new code. We should instead prefer context-less selectors. It makes code more predictable, testable and components more reusable.
 * For example instead of using wrapper selector `hasSelectedEnterpriseMewsMerchant`, prefer directly using `hasEnterpriseMewsMerchant`.
 */

export const hasSelectedEnterpriseMewsMerchant = composeProps(
    hasEnterpriseMewsMerchant,
    selectedEnterpriseIdPropsExtender
);

export const getSelectedEnterpriseSupportedPaymentCardTypes = composeProps(
    getEnterpriseSupportedPaymentCardTypes,
    selectedEnterpriseIdPropsExtender
);

export const getSelectedEnterpriseSupportedPaymentMethods = composeProps(
    getEnterpriseSupportedPaymentMethods,
    selectedEnterpriseIdPropsExtender
);

const hasSelectedEnterpriseNonePaymentGatewayType = composeProps(
    hasEnterpriseNonePaymentGatewayType,
    selectedEnterpriseIdPropsExtender
);

export const hasSelectedEnterprisePciProxyStorage = composeProps(
    hasEnterprisePciProxyStorage,
    selectedEnterpriseIdPropsExtender
);

export const hasSelectedEnterprisePaymentGateway = createSelector(
    hasSelectedEnterpriseNonePaymentGatewayType,
    (hasNonePaymentGatewayType) => !hasNonePaymentGatewayType
);

export const isSelectedEnterpriseModelMerchantOfRecord = composeProps(
    isEnterpriseModelMerchantOfRecord,
    selectedEnterpriseIdPropsExtender
);
